module.exports = __webpack_public_path__ + "static/img/new.3793225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/new.svg
// module id = vfSE
// module chunks = 0